let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d9SRk")).then(() => parcelRequire('cp8J5'));